(function () {
  var canvas = document.getElementById('particle-canvas');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var mouse = { x: -9999, y: -9999 };
  var particles = [];
  var COUNT = 60;

  function resize() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }

  function rand(min, max) { return Math.random() * (max - min) + min; }

  function Particle() {
    this.reset();
  }

  Particle.prototype.reset = function () {
    this.x = rand(0, canvas.width);
    this.y = rand(0, canvas.height);
    this.r = rand(0.6, 1.8);
    this.vx = rand(-0.12, 0.12);
    this.vy = rand(-0.12, 0.12);
    this.alpha = rand(0.2, 0.55);
  };

  Particle.prototype.update = function () {
    var dx = this.x - mouse.x;
    var dy = this.y - mouse.y;
    var dist = Math.sqrt(dx * dx + dy * dy);
    var influence = 120;

    if (dist < influence) {
      var force = (influence - dist) / influence * 0.4;
      this.vx += (dx / dist) * force;
      this.vy += (dy / dist) * force;
    }

    this.vx *= 0.97;
    this.vy *= 0.97;
    this.x += this.vx;
    this.y += this.vy;

    if (this.x < 0) this.x = canvas.width;
    if (this.x > canvas.width) this.x = 0;
    if (this.y < 0) this.y = canvas.height;
    if (this.y > canvas.height) this.y = 0;

    // Easter egg: rare star pulse
    if (this.pulseT > 0) {
      this.pulseT -= 0.018;
      if (this.pulseT < 0) this.pulseT = 0;
    }
  };

  Particle.prototype.draw = function () {
    var color, radius;
    if (this.pulseT > 0) {
      var t = Math.sin(this.pulseT * Math.PI);
      color = 'rgba(51,181,181,' + (this.alpha + t * 0.8) + ')';
      radius = this.r + t * 3;
    } else {
      color = 'rgba(255,255,255,' + this.alpha + ')';
      radius = this.r;
    }
    ctx.beginPath();
    ctx.arc(this.x, this.y, radius, 0, Math.PI * 2);
    ctx.fillStyle = color;
    ctx.fill();
  };

  // Trigger a rare nova pulse on a random particle (~every 15s)
  function maybeNova() {
    if (Math.random() < 0.0011) {
      var p = particles[Math.floor(Math.random() * particles.length)];
      p.pulseT = 1;
    }
  }

  function init() {
    resize();
    for (var i = 0; i < COUNT; i++) {
      var p = new Particle();
      p.pulseT = 0;
      particles.push(p);
    }
  }

  function loop() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    maybeNova();
    for (var i = 0; i < particles.length; i++) {
      particles[i].update();
      particles[i].draw();
    }
    requestAnimationFrame(loop);
  }

  window.addEventListener('resize', resize);
  window.addEventListener('mousemove', function (e) {
    mouse.x = e.clientX;
    mouse.y = e.clientY;
  });
  window.addEventListener('mouseleave', function () {
    mouse.x = -9999;
    mouse.y = -9999;
  });

  init();
  loop();
})();
